import React from 'react';

const InvoiceHistory = () => {
  return (
    <div className="card p-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
        Invoice History
      </h1>
      <p className="text-gray-600 dark:text-gray-400">
        Invoice history functionality will be implemented here.
      </p>
    </div>
  );
};

export default InvoiceHistory;
